import classNames from 'classnames'
import React from 'react'

const Star: React.FC<{ active?: boolean }> = ({ active = false }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" fill="none" viewBox="0 0 15 13">
		<path
			className={classNames({
				'fill-brand-primary-md': active,
				'fill-[#E6E6E6]': !active,
			})}
			d="M8.099.214l1.74 4.104 4.457.382a.35.35 0 01.2.613l-3.38 2.917 1.013 4.34a.35.35 0 01-.524.378l-3.83-2.3-3.829 2.3a.35.35 0 01-.523-.378l1.013-4.34-3.38-2.918a.35.35 0 01.2-.613l4.456-.381L7.452.214a.351.351 0 01.647 0z"
		/>
	</svg>
)

export default Star
